import { CharacterVoiceType } from '@/types/schema';

export const getSelectValue = (value: string | { value?: string } | null | undefined) => {
  if (typeof value === 'string') {
    return value;
  }

  return value?.value || '';
};

export const getVoiceOptions = ({
  voices,
  languageValue,
  genderValue,
}: {
  voices: CharacterVoiceType[];
  languageValue?: string;
  genderValue?: string | null;
}) => {
  return voices.filter((voice) => {
    const languageMatch = languageValue ? voice.language === languageValue : true;
    const genderMatch = genderValue ? voice.gender === genderValue : true;
    return languageMatch && genderMatch;
  });
};

export const getDefaultVoice = ({
  voices,
  languageValue,
  genderValue,
  preferredVoiceValue,
}: {
  voices: CharacterVoiceType[];
  languageValue?: string;
  genderValue?: string | null;
  preferredVoiceValue?: string;
}) => {
  const matchedVoices = getVoiceOptions({ voices, languageValue, genderValue });
  const preferredVoice = preferredVoiceValue
    ? voices.find((voiceOption) => voiceOption.voice_id === preferredVoiceValue)
    : undefined;
  const languageOnlyVoices = getVoiceOptions({ voices, languageValue });
  const genderOnlyVoices = getVoiceOptions({ voices, genderValue });

  if (
    preferredVoiceValue &&
    matchedVoices.some((voiceOption) => voiceOption.voice_id === preferredVoiceValue)
  ) {
    return preferredVoiceValue;
  }

  if (matchedVoices[0]?.voice_id) {
    return matchedVoices[0].voice_id;
  }

  if (preferredVoice?.voice_id) {
    return preferredVoice.voice_id;
  }

  if (languageOnlyVoices[0]?.voice_id) {
    return languageOnlyVoices[0].voice_id;
  }

  if (genderOnlyVoices[0]?.voice_id) {
    return genderOnlyVoices[0].voice_id;
  }

  return voices[0]?.voice_id || '';
};
